<template>
  <div id="app" :class="themeClass">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapState({
      theme: state => state.settings.theme
    }),
    themeClass() {
      return this.theme === 'dark' ? 'dark-theme' : ''
    }
  },
  watch: {
    theme(newTheme) {
      this.updateBodyClass(newTheme)
    }
  },
  mounted() {
    // 初始化时应用主题
    this.updateBodyClass(this.theme)
  },
  methods: {
    updateBodyClass(theme) {
      if (theme === 'dark') {
        document.body.classList.add('dark-theme')
      } else {
        document.body.classList.remove('dark-theme')
      }
    }
  }
}
</script>

<style lang="scss">
@import '~normalize.css/normalize.css';
/*// normalize.css 样式格式化*/
@import './styles/index.scss';
/*// 全局自定义的css样式*/
@import './styles/font/iconfont.css';

//解决table 组件开启固定后 导致底部滚动条无法拖拽的问题
.el-table .el-table__fixed, .el-table .el-table__fixed-right {
  height: auto !important;
  bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue